import { render, staticRenderFns } from "./TrainingTest.vue?vue&type=template&id=0a0f14d5&scoped=true&"
import script from "./TrainingTest.vue?vue&type=script&lang=js&"
export * from "./TrainingTest.vue?vue&type=script&lang=js&"
import style0 from "./TrainingTest.vue?vue&type=style&index=0&id=0a0f14d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f14d5",
  null
  
)

export default component.exports